const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTesting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "25.6px",
    viewBox: "0 0 28 25.6",
    style: {
      enableBackground: "new 0 0 28 25.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M27.8,21L20.1,7.1l0-4.3h1.3c0.8,0,1.4-0.6,1.4-1.4S22.2,0,21.4,0h-2.6c0,0,0,0,0,0H6.1 C5.3,0,4.7,0.6,4.7,1.4s0.6,1.4,1.4,1.4h1.4v5L0.2,21C0.1,21.2,0,21.5,0,21.7c0,2.2,1.8,3.9,3.9,3.9h20.2c2.2,0,3.9-1.8,3.9-3.9 C28,21.5,27.9,21.2,27.8,21z M17.3,2.8l0,4.6c0,0.2,0.1,0.5,0.2,0.7l1.9,3.5c-2.7-0.4-4.7,0.4-6.4,0.9c-1.8,0.7-3.2,1.2-5.3,0.5 L10,8.8c0.1-0.2,0.2-0.4,0.2-0.7V2.8H17.3z M24.1,22.8H3.9c-0.5,0-0.9-0.4-1.1-0.8l3.6-6.6c3.4,1.3,5.9,0.7,7.9-0.4 c2.5-1.3,5.4-0.9,6.5-0.6l4.2,7.7C25,22.5,24.6,22.8,24.1,22.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting);
export default __webpack_public_path__ + "static/media/testing.99b1b122849db1063a6479cbc3c81288.svg";
export { ForwardRef as ReactComponent };